
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  Contact.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\Contact.ts

import {Civility } from "./Civility";
import {ContactStoredData } from "./ContactStoredData";
import {ExtUser } from "./ExtUser";
import {IntUser } from "./IntUser";
import {SupplierContact } from "./SupplierContact";
import {SupplierMail } from "./SupplierMail";
import {SupplierUpdateComment } from "./SupplierUpdateComment";
export class Contact {

  // int Id
  public Id: number=0;

  // int CivId
  public CivId: number=0;

  // string Firstname
  public Firstname?: string=null;

  // string Lastname
  public Lastname?: string=null;

  // string Fonction
  public Fonction?: string=null;

  // string Email
  public Email?: string=null;

  // string Phone
  public Phone?: string=null;

  // string CellPhone
  public CellPhone?: string=null;

  // DateTime? CreationDate
  public CreationDate?: Date=null;

  // string CreationUserId
  public CreationUserId?: string=null;

  // string LngCod
  public LngCod?: string=null;

  // string Comments
  public Comments?: string=null;

  // string EmailDiff
  public EmailDiff?: string=null;

  // Civility Civility
  public Civility: Civility=null;

  // ICollection<ContactStoredData> ContactStoredDatas
  public ContactStoredDatas: ContactStoredData[]=[];

  // ICollection<ExtUser> ExtUsers
  public ExtUsers: ExtUser[]=[];

  // ICollection<IntUser> IntUsers
  public IntUsers: IntUser[]=[];

  // ICollection<SupplierContact> SupplierContacts
  public SupplierContacts: SupplierContact[]=[];

  // ICollection<SupplierMail> SupplierMails
  public SupplierMails: SupplierMail[]=[];

  // ICollection<SupplierUpdateComment> SupplierUpdateComments
  public SupplierUpdateComments: SupplierUpdateComment[]=[];
}